var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMail2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 18,
    viewBox: "0 0 22 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3 2C2.45228 2 2 2.45228 2 3V15C2 15.5477 2.45228 16 3 16H19C19.5477 16 20 15.5477 20 15V3C20 2.45228 19.5477 2 19 2H3ZM0 3C0 1.34772 1.34772 0 3 0H19C20.6523 0 22 1.34772 22 3V15C22 16.6523 20.6523 18 19 18H3C1.34772 18 0 16.6523 0 15V3Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.180854 2.42662C0.497568 1.97417 1.1211 1.86414 1.57355 2.18085L11.0001 8.77943L20.4266 2.18085C20.8791 1.86414 21.5026 1.97417 21.8193 2.42662C22.136 2.87907 22.026 3.5026 21.5735 3.81932L11.5735 10.8193C11.2292 11.0603 10.7709 11.0603 10.4266 10.8193L0.426623 3.81932C-0.0258258 3.5026 -0.135861 2.87907 0.180854 2.42662Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMail2);
export default __webpack_public_path__ + "static/media/mail2.83c7db18749b967888d9656803c0f5f5.svg";
export { ForwardRef as ReactComponent };